import dayjs from "dayjs";
import { tlsPrescriptionTrigger } from "parog-web/utils/alert";
import type { TlsPrescriptionTrigger } from "./alert-triggered-journal-event";
import type AlertTriggeredJournalEvent from "./alert-triggered-journal-event";

export default class TlsAlertModelView {
  public followUpReason;
  public healthCentreName;
  public id;
  public isRenewal;
  public patientId;
  public patientName;
  public referentMedicName;
  public validityPeriod;

  private get nextPrescriptionStartDate() {
    return new Date(this.tlsPrescriptionTrigger.nextPrescriptionStartDate);
  }

  private get tlsPrescriptionTrigger(): TlsPrescriptionTrigger {
    return tlsPrescriptionTrigger(this.alertTriggeredJournalEvent);
  }

  constructor(public alertTriggeredJournalEvent: AlertTriggeredJournalEvent) {
    const patient = alertTriggeredJournalEvent.patient;

    this.id = alertTriggeredJournalEvent.id;
    this.patientName = patient.fullName;
    this.patientId = patient.id;
    this.followUpReason = patient.followUpReason;
    this.healthCentreName = patient.healthCentre.name;
    this.referentMedicName = patient.referentMedic?.fullName;
    this.isRenewal = alertTriggeredJournalEvent.isTlsRenewal;
    this.validityPeriod = this.computeValidityDates();
  }

  public isBefore(tlsAlert: TlsAlertModelView) {
    return dayjs(this.nextPrescriptionStartDate).isBefore(
      tlsAlert.nextPrescriptionStartDate
    )
      ? 1
      : -1;
  }

  private computeValidityDates(): string {
    const trigger = this.tlsPrescriptionTrigger;
    const startDate = new Date(trigger.nextPrescriptionStartDate);
    const endDate = new Date(trigger.nextPrescriptionEndDate);

    return startDate && endDate
      ? `Du ${startDate.toLocaleDateString("fr-FR", {
          day: "2-digit",
          month: "2-digit"
        })} au ${endDate.toLocaleDateString("fr-FR")}`
      : "";
  }
}
